import { tsValidateString, tsValidateUniqueId, tsValidator_nonMandatoryString } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
import { DBDef_NoteTemplate } from '@app/advisor-content-shared';
const Validator_ModifiableProps = {
    name: tsValidateString(),
    address: tsValidateString(-1, false),
    organizationId: tsValidateUniqueId,
    parentId: tsValidator_nonMandatoryString,
    advisorConfigurationId: tsValidateUniqueId,
    noteTemplateId: tsValidateUniqueId,
    timezone: tsValidateString(),
};
const Validator_GeneratedProps = {};
export const DBDef_Facility = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'facility',
    entityName: 'Facility',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'facility'
    },
    backend: {
        name: 'facility'
    },
    dependencies: {
        organizationId: {
            dbKey: 'organizations',
            fieldType: 'string'
        },
        advisorConfigurationId: {
            dbKey: 'advisor-configurations',
            fieldType: 'string'
        },
        noteTemplateId: {
            dbKey: DBDef_NoteTemplate.dbKey,
            fieldType: 'string'
        },
        parentId: {
            dbKey: 'facility',
            fieldType: 'string',
        }
    }
};
//# sourceMappingURL=db-def.js.map